export default __webpack_public_path__ + "static/media/5.b8669f02.png";